import { Component, OnInit } from '@angular/core';
import { VideoUploadComponent } from "../../features/video/view/video-upload/video-upload.component";
import { VideoQueryElementsComponent } from "../../features/handball/video-quering/view/video-query-elements/video-query-elements.component";
import { QueryElementsConfig } from 'src/app/features/handball/video-quering/model/query-elements-config';
import { CommonModule } from '@angular/common';
import { FilterModel } from 'src/app/features/handball/video-quering/model/filter-model';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-upload-video',
  templateUrl: 'upload-video.component.html',
  styleUrls: ['upload-video.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, VideoUploadComponent, VideoQueryElementsComponent]
})
export class UploadVideoComponent implements OnInit {

  filters: FilterModel = null;
  queryElementsConfig: QueryElementsConfig;

  otherCategory: string;
  otherCompetition: string;
  otherChampionship: string;

  constructor() { }

  ngOnInit() {
    this.queryElementsConfig = {
      gender: { visible: true },
      category: { visible: true, allowOtherCustomField: true },
      competition: { visible: true, allowOtherCustomField: true },
      championship: { visible: true, allowOtherCustomField: true },
      dateStart: { visible: false },
      dateEnd: { visible: false },
    };
  }

  protected onFiltersChange(filter: FilterModel) {
    this.filters = filter;
  }

}
